(function () {
  var DEBOUNCE_MS = 220;
  var MAX_PRODUCTS = 6;
  var SUGGEST_LIMIT = 10;
  var BODY_CLASS = 'is-predictive-search-open';
  var openPredictiveRoots = new Set();

  function syncPredictiveSearchBodyClass() {
    document.body.classList.toggle(BODY_CLASS, openPredictiveRoots.size > 0);
  }

  function debounce(fn, ms) {
    var t;
    var wrapped = function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, ms);
    };
    wrapped.cancel = function () {
      clearTimeout(t);
    };
    return wrapped;
  }

  function productImageUrl(product) {
    if (product.featured_image && product.featured_image.url) return product.featured_image.url;
    if (typeof product.image === 'string') return product.image;
    return '';
  }

  function firstSku(product) {
    if (!product.variants || !product.variants.length) return '';
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].sku) return product.variants[i].sku;
    }
    return '';
  }

  function formatMoney(amount, currencyCode) {
    var n = typeof amount === 'number' ? amount : parseFloat(String(amount));
    if (isNaN(n)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currencyCode || 'USD',
      }).format(n);
    } catch (e) {
      return String(n);
    }
  }

  function displayPrice(product) {
    var cur = product.currency_code;
    if (product.price_min != null && product.price_max != null && product.price_min !== product.price_max) {
      return formatMoney(product.price_min, cur) + ' – ' + formatMoney(product.price_max, cur);
    }
    return formatMoney(product.price != null ? product.price : product.price_min, cur);
  }

  function filterByTitleSubstring(products, q) {
    if (!q) return [];
    var needle = q.toLowerCase();
    var out = [];
    for (var i = 0; i < products.length; i++) {
      var t = (products[i].title || '').toLowerCase();
      if (t.indexOf(needle) !== -1) out.push(products[i]);
      if (out.length >= MAX_PRODUCTS) break;
    }
    return out;
  }

  function buildSuggestUrl(base, q) {
    var params = new URLSearchParams();
    params.set('q', q);
    params.append('resources[type]', 'product');
    params.set('resources[limit]', String(SUGGEST_LIMIT));
    params.set('resources[limit_scope]', 'each');
    params.append('resources[options][fields]', 'title');
    params.append('resources[options][unavailable_products]', 'last');
    var sep = base.indexOf('?') === -1 ? '?' : '&';
    return base + sep + params.toString();
  }

  function bindRoot(root) {
    var suggestUrl = root.getAttribute('data-suggest-url');
    var searchUrl = root.getAttribute('data-search-url') || '/search';
    var currencyCode = root.getAttribute('data-currency-code') || 'USD';
    var emptyMsg = root.getAttribute('data-msg-empty') || 'No products found';
    var input = root.querySelector('[data-predictive-search-input]');
    var panel = root.querySelector('[data-predictive-dropdown]');
    var resultsEl = root.querySelector('[data-predictive-results]');
    var loadingEl = root.querySelector('[data-predictive-loading]');
    var emptyEl = root.querySelector('[data-predictive-empty]');
    var headingEl = root.querySelector('[data-predictive-heading]');
    var viewAll = root.querySelector('[data-predictive-view-all]');
    if (!suggestUrl || !input || !panel || !resultsEl) return;

    var abortCtrl = null;
    var form = input.form;

    function setOpen(open) {
      panel.hidden = !open;
      input.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        openPredictiveRoots.add(root);
      } else {
        openPredictiveRoots.delete(root);
      }
      syncPredictiveSearchBodyClass();
    }

    function hidePanel() {
      setOpen(false);
    }

    function showLoading(show) {
      if (loadingEl) loadingEl.hidden = !show;
    }

    function setProductsHeadingVisible(show) {
      if (headingEl) headingEl.hidden = !show;
    }

    function renderProducts(products, q) {
      resultsEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = products.length > 0;
      setProductsHeadingVisible(products.length > 0);

      for (var i = 0; i < products.length; i++) {
        var p = products[i];
        p.currency_code = p.currency_code || currencyCode;
        var sku = firstSku(p);
        var imgUrl = productImageUrl(p);
        var priceStr = displayPrice(p);

        var article = document.createElement('article');
        article.className = 'header-predictive-card';
        article.setAttribute('role', 'listitem');

        var link = document.createElement('a');
        link.className = 'header-predictive-card__link';
        link.href = p.url || '#';

        if (imgUrl) {
          var img = document.createElement('img');
          img.className = 'header-predictive-card__img';
          img.src = imgUrl;
          img.alt = '';
          img.width = 72;
          img.height = 72;
          img.loading = 'lazy';
          link.appendChild(img);
        }

        var body = document.createElement('div');
        body.className = 'header-predictive-card__body';

        var title = document.createElement('p');
        title.className = 'header-predictive-card__title';
        title.textContent = p.title || '';

        body.appendChild(title);

        if (sku) {
          var skuEl = document.createElement('p');
          skuEl.className = 'header-predictive-card__sku';
          skuEl.textContent = 'SKU: ' + sku;
          body.appendChild(skuEl);
        }

        if (priceStr) {
          var priceEl = document.createElement('p');
          priceEl.className = 'header-predictive-card__price';
          priceEl.textContent = priceStr;
          body.appendChild(priceEl);
        }

        link.appendChild(body);
        article.appendChild(link);
        resultsEl.appendChild(article);
      }

      if (viewAll && q) {
        var qs = new URLSearchParams();
        qs.set('q', q);
        qs.set('type', 'product');
        qs.set('options[prefix]', 'last');
        viewAll.href = searchUrl + (searchUrl.indexOf('?') === -1 ? '?' : '&') + qs.toString();
        viewAll.hidden = false;
      } else if (viewAll) {
        viewAll.hidden = true;
      }
    }

    function runSearch(q) {
      if (abortCtrl) abortCtrl.abort();
      if (!q.length) {
        showLoading(false);
        setProductsHeadingVisible(false);
        resultsEl.innerHTML = '';
        if (emptyEl) emptyEl.hidden = true;
        hidePanel();
        return;
      }

      abortCtrl = new AbortController();
      showLoading(true);
      setProductsHeadingVisible(false);
      resultsEl.innerHTML = '';
      if (viewAll) viewAll.hidden = true;
      setOpen(true);
      if (emptyEl) emptyEl.hidden = true;

      fetch(buildSuggestUrl(suggestUrl, q), {
        signal: abortCtrl.signal,
        headers: { Accept: 'application/json' },
      })
        .then(function (res) {
          if (!res.ok) throw new Error(String(res.status));
          return res.json();
        })
        .then(function (data) {
          showLoading(false);
          var raw = (data.resources && data.resources.results && data.resources.results.products) || [];
          var filtered = filterByTitleSubstring(raw, q);
          renderProducts(filtered, q);
          if (!filtered.length && emptyEl) {
            emptyEl.hidden = false;
            emptyEl.textContent = emptyMsg;
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          showLoading(false);
          resultsEl.innerHTML = '';
          setProductsHeadingVisible(false);
          if (emptyEl) {
            emptyEl.hidden = false;
            emptyEl.textContent = emptyMsg;
          }
        });
    }

    var debouncedSearch = debounce(function () {
      runSearch(input.value.trim());
    }, DEBOUNCE_MS);

    input.addEventListener('input', function () {
      var v = input.value.trim();
      if (!v.length) {
        debouncedSearch.cancel();
        runSearch('');
        return;
      }
      debouncedSearch();
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length) runSearch(input.value.trim());
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        hidePanel();
        input.blur();
      }
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) hidePanel();
    });

    if (form) {
      form.addEventListener('submit', function () {
        hidePanel();
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-predictive-search-root]').forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
